import { createGlobalStyle } from "styled-components";

const styled = { createGlobalStyle };

const GlobalStyles = styled.createGlobalStyle`
  /* Dizajn tokeni, 3-slojna topla paleta (blagi braon/narandžasti podton).
     Jedini izvor istine za boje; sve nove komponente koriste isključivo ove. */
  :root {
    /* Površine */
    --bg-app: #131010; /* najtamnije, pozadina aplikacije */
    --bg-sidebar: #191413;
    --bg-surface: #201a17; /* tabele, kartice, najsvetlije */
    --bg-surface-2: #171310; /* header redovi tabela, tamniji topli */
    --bg-elevated: #2a2320; /* chipovi, hover površine iznad kartica */

    /* Ivice */
    --border: rgba(255, 255, 255, 0.06);
    --border-strong: rgba(255, 255, 255, 0.12);

    /* Brend */
    --brand: #ff6b35;
    --brand-hover: #e55a2b;
    --brand-dim: rgba(255, 107, 53, 0.14); /* pozadina aktivnih chipova */

    /* Tekst */
    --text-primary: #f5f2ef;
    --text-secondary: #b8b2ac;
    --text-muted: #837d77;

    /* Statusi */
    --danger: #ff6b6b;
    --success: #3ddc74;

    /* Oblici */
    --radius-card: 10px;
    --radius-control: 6px;
    --radius-pill: 999px;

    /* Tipografija */
    --font-display: "Archivo Black", "Archivo", sans-serif;
    --font-body: "Archivo", sans-serif;
  }

  *,
  *::after,
  *::before {
    box-sizing: inherit;
    margin: 0;
    padding: 0;
    scroll-behavior: smooth;
  }

  /* UI-05: tanak, stilizovan scrollbar umesto potpuno skrivenog,
     da korisnik vidi poziciju u dugačkim listama. */
  * {
    scrollbar-width: thin;
    scrollbar-color: ${({ theme }) => theme.colors.primary} transparent;
  }

  input,
  button,
  select {
    outline: none;
  }

  *::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  *::-webkit-scrollbar-track {
    background: transparent;
  }

  *::-webkit-scrollbar-thumb {
    background-color: ${({ theme }) => theme.colors.primary};
    border-radius: ${({ theme }) => theme.radius.pill};
  }

  /* Glavni (window) scrollbar sakriven, poziciju na stranici pokazuje
     progress linija u headeru; unutrašnje liste zadržavaju tanki scrollbar */
  html {
    scrollbar-width: none;
    -ms-overflow-style: none;
  }

  html::-webkit-scrollbar {
    display: none;
    width: 0;
    height: 0;
  }

  a {
    color: ${({ theme }) => theme.colors.primary};
  }

  html {
    height: 100%;
    /* font-size: 62.5%; // 1rem = 10px, 10/16 = 60.25% */
    box-sizing: border-box;

    @media screen and (max-width: 1200px) {
      font-size: 85%; //1rem = 8px, 8/16 = 50%
    }

    @media screen and (max-width: 768px) {
      font-size: 75%; //1rem = 8px, 8/16 = 50%
    }
  }
  body {
    font-family: var(--font-body);
    box-sizing: border-box;
    background: var(--bg-app);
    color: var(--text-primary);
    line-height: 1.6;
    /* UI-04: uklonjen 'user-select: none', kupci treba da mogu da kopiraju
       tekst (ime proizvoda, broj porudžbine, cenu, adresu). */
    outline: none;
  }

  /* Noise tekstura 2–3% preko cele aplikacije (editorial-punk zrno).
     pointer-events: none, čisto dekorativno. */
  body::after {
    content: "";
    position: fixed;
    inset: 0;
    z-index: 9999;
    pointer-events: none;
    opacity: 0.025;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='160' height='160'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='2' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E");
  }

  h1,
  h2,
  h3,
  h4,
  h5 {
    font-family: ${({ theme }) => theme.fonts.bold};
  }

  p,
  span,
  a,
  li {
    font-family: ${({ theme }) => theme.fonts.regular};
  }

  button {
    font-family: ${({ theme }) => theme.fonts.semibold};
  }

  /* UI-06: uklonjen 'background-color: red' (deluje kao zaostao debug). */
  input[type="date"]::-webkit-calendar-picker-indicator {
    opacity: 0;
    z-index: 2;
    cursor: pointer;
    position: absolute;
    right: 0.8rem;
    width: 15px;
    height: 15px;
  }

  input[type="time"]::-webkit-calendar-picker-indicator {
    opacity: 0;
    z-index: 2;
    cursor: pointer;
    position: absolute;
    right: 0.8rem;
    width: 15px;
    height: 15px;
  }

  select {
    -webkit-appearance: none; /* Safari, Chrome */
    -moz-appearance: none; /* Firefox */
    appearance: none; /* Standard */
    background: none; /* skida default pozadinu */
  }

  /* Ako hoćeš i da ukloniš strelicu u Internet Explorer/Edge starijem */
  select::-ms-expand {
    display: none;
  }

  input {
    position: relative;
  }

  /* Number inputi bez nativnih strelica (spinner), vrednost se kuca */
  input[type="number"]::-webkit-outer-spin-button,
  input[type="number"]::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  input[type="number"] {
    -moz-appearance: textfield;
    appearance: textfield;
  }
  input[type="checkbox"] {
    appearance: none; /* skida default izgled */
    -webkit-appearance: none;
    -moz-appearance: none;

    width: 16px;
    height: 16px;
    border-radius: 4px;
    border: 1.5px solid ${({ theme }) => theme.colors.primary};
    background-color: transparent;
    cursor: pointer;
    position: relative;
  }

  input[type="checkbox"]:checked {
    background-color: ${({ theme }) => theme.colors.primary};
    border-color: ${({ theme }) => theme.colors.primary};
  }

  input[type="checkbox"]:checked::after {
    content: "✔";
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 12px;
    color: ${({ theme }) => theme.colors.black}; /* crni checkmark */
  }
`;

export default GlobalStyles;

/* MEDIA QUERY MANAGER
0 - 600px:  Phone
600 - 900px:  Tablet portrait
900 - 1200px:  Tablet landscape
[1200 - 1800] is where our normal styles apply
1800px+ :  Big desktop
*/
